import { MutationTree } from 'vuex';
import { deepClone } from 'fast-json-patch/lib/core';
import _findIndex from 'lodash/findIndex';

import { TabViewModel } from '../../models/common/tab-view.model';
import {
    ITabViewState,
    TAB_VIEW_MUNTATIONS,
    AddTabParamModel,
    SetUnsavedDataParamModel,
    UpdateTabIdParamModel
} from './tab-view-types.store';
import { 
    // LEAVE_PAGE_CONFIRM_ACTIONS, 
    ROUTER,
    PAGE_VIEW_TYPES } from '../../common/constants';
import { findTabViewHandler } from '../../utils/util';

import { LocalforageWrapper } from '../../utils/localforage-wrapper';


const saveTabViewToStorage = (data) => { // call save to storage when ever tabview change
    setTimeout(() => {
      const tabViews = deepClone(data);
      tabViews.forEach(element => {
        if (element.callbackClose) {
          // remove call back 
          delete element.callbackClose;
        }
        if (element.callBackClearMemory) {
          // remove call back 
          delete element.callBackClearMemory;
        }
        element.unSavedData = false;
      });
      // Save data to indexDB
      LocalforageWrapper.setItem('Tab_views', tabViews);
    }, 300)
    
}

export const mutations: MutationTree<ITabViewState> = {
    [TAB_VIEW_MUNTATIONS.ADD_TAB](state, data: AddTabParamModel) {
        const payload: TabViewModel = data.tab;

        const tab = state.tabViews.find((tab: TabViewModel) => {
            return findTabViewHandler(tab, payload);
        })

        if (payload.persistent) {
            const shouldReplace = state.tabViews.length > 0 && state.tabViews[0].persistent;
            if (shouldReplace) {
                state.tabViews[0] = payload;
            } else {
                state.tabViews.unshift(payload);
            }
        } else {
            if (!tab) {
                let replaceSameObjectTabIndex = -1;
                if(payload.identifyData.name === ROUTER.AGENDA.AGENDA_EDIT_OCCURRENCE || payload.identifyData.name === ROUTER.AGENDA.AGENDA_EDIT_SERIES) {
                    const replaceTab = payload.identifyData.name === ROUTER.AGENDA.AGENDA_EDIT_OCCURRENCE 
                        ? ROUTER.AGENDA.AGENDA_EDIT_SERIES : ROUTER.AGENDA.AGENDA_EDIT_OCCURRENCE;
                        replaceSameObjectTabIndex = state.tabViews.findIndex((item: TabViewModel) => {
                            return item.identifyData.moduleType === payload.identifyData.moduleType
                                && item.identifyData.name === replaceTab
                                && item.identifyData.id == payload.identifyData.id;
                        })
                } else if (payload.identifyData.viewType === PAGE_VIEW_TYPES.EDIT) {
                    replaceSameObjectTabIndex = state.tabViews.findIndex((item: TabViewModel) => {
                        return item.identifyData.moduleType === payload.identifyData.moduleType
                            && (item.identifyData.viewType === PAGE_VIEW_TYPES.NEW || item.identifyData.viewType === PAGE_VIEW_TYPES.DETAIL)
                            && item.identifyData.id == payload.identifyData.id;
                    })
                } else if (payload.identifyData.viewType === PAGE_VIEW_TYPES.DETAIL) {
                    replaceSameObjectTabIndex = state.tabViews.findIndex((item: TabViewModel) => {
                        return item.identifyData.moduleType === payload.identifyData.moduleType
                            && item.identifyData.viewType === PAGE_VIEW_TYPES.EDIT
                            && item.identifyData.id == payload.identifyData.id;
                    })
                }
                console.log('sameObjectNewTabIndex: ', replaceSameObjectTabIndex)
                if (replaceSameObjectTabIndex > -1) {
                    state.tabViews.splice(replaceSameObjectTabIndex, 1, payload);
                } else {
                    if (!state.activeTab) {
                        state.tabViews.unshift(payload);
                    } else {
                        const activeTabIndex = state.tabViews.findIndex((item: TabViewModel) => {
                            return findTabViewHandler(item, state.activeTab);
                        })
                        state.tabViews.splice(activeTabIndex + 1, 0, payload);
                    }
                }
            }

        }
        
        if (data.setActive) state.activeTab = tab ? tab : payload;
        
        saveTabViewToStorage(state.tabViews);
    },
    [TAB_VIEW_MUNTATIONS.REMOVE_TAB](state, data: TabViewModel) {
        const tabIndex = state.tabViews.findIndex((tab: TabViewModel) => {
            return findTabViewHandler(tab, data);
        })
        if (tabIndex > -1) {
            state.tabViews.splice(tabIndex, 1);
        }

        saveTabViewToStorage(state.tabViews);
    },
    [TAB_VIEW_MUNTATIONS.SET_TAB_VIEWS](state, data: any) {
        if (state.tabViews.length === 1 && state.activeTab.callBackClearMemory) {
            const index = _findIndex(data, (item) => item.url === state.activeTab.url);
            data[index] = state.activeTab;
        }
        state.tabViews = [...data];
    },
    [TAB_VIEW_MUNTATIONS.SET_UNSAVED_DATA](state, payload: SetUnsavedDataParamModel) {
        const tab = state.tabViews.find((tab: TabViewModel) => {
            return findTabViewHandler(tab, payload);
        })
        if (tab) { tab.unSavedData = payload.value; }
        // if (tab.unSavedData) {
        //     tab.confirmActions = payload.confirmActions
        //         ? payload.confirmActions
        //         : [
        //             LEAVE_PAGE_CONFIRM_ACTIONS.SAVE,
        //             LEAVE_PAGE_CONFIRM_ACTIONS.CONTINUE,
        //             LEAVE_PAGE_CONFIRM_ACTIONS.DISCARD
        //         ]
        // }
    },
    [TAB_VIEW_MUNTATIONS.ADD_QUERY_STRING_TAB_VIEW](state, data: Object) {
        const tabIndex = state.tabViews.findIndex((tab: TabViewModel) => {
            return findTabViewHandler(tab, state.activeTab);
        })
        if (tabIndex > -1) {
            state.tabViews[tabIndex].query = { ...state.tabViews[tabIndex].query, ...data };
            state.activeTab.query = { ...state.activeTab.query, ...data };
        }
    },
    [TAB_VIEW_MUNTATIONS.UPDATE_TABVIEW_QUERY](state, data: Object) {
        const tabIndex = state.tabViews.findIndex((tab: TabViewModel) => {
            return findTabViewHandler(tab, state.activeTab);
        })
        if (tabIndex > -1) {
            state.tabViews[tabIndex].query = { ...data };
            state.activeTab.query = { ...data };
        }
    },
    [TAB_VIEW_MUNTATIONS.SET_CALLBACK_CLOSE_TAB_VIEW](state, payload: { callback: any, tab: TabViewModel }) {
        const tabIndex = state.tabViews.findIndex((tab: TabViewModel) => {
            return findTabViewHandler(tab, payload.tab);
        })
        if (tabIndex > -1 && typeof payload.callback === 'function') {
            state.tabViews[tabIndex].callbackClose = payload.callback;
            // Only mirror onto activeTab when it IS the targeted tab — a background tab registering
            // its callback (e.g. the email editor's late dirty-state message) must not overwrite
            // the close handler of whatever tab the user is currently on.
            if (state.activeTab && findTabViewHandler(state.activeTab, payload.tab)) {
                state.activeTab.callbackClose = payload.callback;
            }
        }
    },
    [TAB_VIEW_MUNTATIONS.SET_CALLBACK_CLEAR_MEMORY](state, payload: { callback: any, tab: TabViewModel }) {
        const tabIndex = state.tabViews.findIndex((tab: TabViewModel) => {
            return findTabViewHandler(tab, payload.tab);
        })
        if (tabIndex > -1 && typeof payload.callback === 'function') {
            state.tabViews[tabIndex].callBackClearMemory = payload.callback;
            state.activeTab.callBackClearMemory = payload.callback;
        }
    },
    [TAB_VIEW_MUNTATIONS.UPDATE_TAB_IDENTIFY_ID](state, payload: UpdateTabIdParamModel){
        const tabIndex = state.tabViews.findIndex((tab: TabViewModel) => {
            return findTabViewHandler(tab, payload);
        })
        if (tabIndex > -1) {
            state.tabViews[tabIndex].identifyData.id = payload.newId;
        }
    },
    [TAB_VIEW_MUNTATIONS.UPDATE_TAB_TITLE](state, payload: {tab: TabViewModel, value: string}){
        const tab = state.tabViews.find((tab: TabViewModel) => {
            return findTabViewHandler(tab, payload.tab);
        })
        if (tab) {
            tab.title = payload.value;
        }
        
        saveTabViewToStorage(state.tabViews);
    },
    
    [TAB_VIEW_MUNTATIONS.UPDATE_TABVIEW_ORDER](state, payload: Array<TabViewModel>){
        state.tabViews = [...payload];
        saveTabViewToStorage(state.tabViews);
    },
    [TAB_VIEW_MUNTATIONS.UPDATE_OLD_TAB](state, data: any) {
        state.oldTab = data;
    }

}